import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialSelections = {
	defaultLayout: true,
	alternativeLayout: false
};

const EstimatesModal = ({ show, onClose, onContinue }) => {
	const [selections, setSelections] = useState(initialSelections);
	const [error, setError] = useState("");

	useEffect(() => {
		if (!show) {
			setSelections(initialSelections);
			setError("");
		}
	}, [show]);

	const handleSelectionChange = (event) => {
		const { name, checked } = event.target;
		setSelections((prev) => {
			const updated = { ...prev, [name]: checked };
			if (updated.defaultLayout || updated.alternativeLayout) {
				setError("");
			}
			return updated;
		});
	};

	const handleContinue = () => {
		if (selections.defaultLayout || selections.alternativeLayout) {
			setError("");
			let tmpSelected = 'default';
			if (selections.alternativeLayout) tmpSelected = 'variant';
			if (selections.defaultLayout && selections.alternativeLayout) tmpSelected = 'all';
			onContinue(tmpSelected);
		} else {
			setError("Please select at least one layout option before continuing.");
		}
	};

	return (
		<Modal show={show} size="md" onHide={onClose} centered>
			<Modal.Header closeButton>
				<div className="modal-title h4">Select Layouts</div>
			</Modal.Header>
			<Modal.Body>
				<Form.Check
					type="checkbox"
					id="estimates-default-layout"
					label="Default layout"
					name="defaultLayout"
					checked={selections.defaultLayout}
					onChange={handleSelectionChange}
				/>
				<Form.Check
					type="checkbox"
					id="estimates-alternative-layout"
					label="Alternative layout"
					name="alternativeLayout"
					className="mt-2"
					checked={selections.alternativeLayout}
					onChange={handleSelectionChange}
				/>
				{error ? <p className="text-danger mt-3 mb-0">{error}</p> : null}
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				<Button variant="primary" onClick={handleContinue}>
					Continue
				</Button>
				<Button variant="secondary" onClick={onClose}>
					Cancel
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default EstimatesModal;
